import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsUUID, IsOptional } from 'class-validator'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'

export class ListProgramConceptCompetenciesQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({ type: 'string', description: 'Filter by program concept ID' })
  @IsUUID()
  @IsOptional()
  programConceptId?: string

  @ApiPropertyOptional({ type: 'string', description: 'Filter by program competency ID' })
  @IsUUID()
  @IsOptional()
  programCompetencyId?: string

  @ApiPropertyOptional({ type: 'string', description: 'Filter by program version ID' })
  @IsUUID()
  @IsOptional()
  programVersionId?: string
}
